import React from 'react';
import { createRoot } from 'react-dom/client';

import { setupChunkErrorRecovery } from './bootstrap/chunkErrorRecovery';
import '@fontsource-variable/inter';
import '@fontsource-variable/plus-jakarta-sans';
import App from './App';

setupChunkErrorRecovery();

const root = createRoot(document.getElementById('root'));
root.render(<App />);
